import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue"
import ToggleSwitch from "@/components/ToggleSwitch.vue"
import FormRow from "@/components/Common/FormRow.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleRow',
  props: {
    title: {},
    modelValue: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FormRow, {
    title: props.title
  }, {
    default: _withCtx(() => [
      _createVNode(ToggleSwitch, {
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
        className: "mt-3"
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})